<script lang="ts">
    import CustomerSupport from 'desktop/icons/CustomerSupport.svelte';
    import FreeShipping from 'desktop/icons/FreeShipping.svelte';
    import Guarantee from 'desktop/icons/Guarantee.svelte';
</script>

<style src="./style.css">
</style>

<div class="sv-container">
    <p class="sv-title">Shop with complete confidence</p>
    <div class="conditionsContainer">
        <div class="sv-item">
            <div class="sv-icon">
                <FreeShipping />
            </div>
            Free shipping and returns
        </div>
        <div class="sv-item">
            <div class="sv-icon">
                <Guarantee />
            </div>
            100% money-back guarantee
        </div>
        <div class="sv-item">
            <div class="sv-icon">
                <CustomerSupport />
            </div>
            24/7 customer support
        </div>
    </div>
</div>
